import React, { Component } from 'react';

import { isFunction, isEmpty } from 'lodash';

import { inject, observer } from 'mobx-react';
import { Select, Icon } from 'antd';

import './SubscriptionStatusFilter.css';
import moment from "moment";

@inject('translationsStore', 'subscriptionsStore', 'filterStore')
@observer
export default class SubscriptionStatusFilter extends Component {
  constructor(props) {
    super(props);

    this.state = { visible: this.props.visible};
  }

  componentDidUpdate(prevProps) {
    if (prevProps.status !== this.props.status && this.props.status === false) {
      this.reset();
    }
  }

  selectSubscriptionStatus = subscriptionStatus => {
    this.setState({ subscriptionStatusSelected: subscriptionStatus });
    this.props.filterStore.add('subscriptionFilter_subscriptionStatus', subscription =>
      moment(subscription.end_date).isBefore(moment())? 'expired' : 'active' === subscriptionStatus
    );
  };

  reset = () => {
    if (isFunction(this.props.reset)) {
      this.props.apply();
    }
    if (this.props.reset !== false) {
      this.setState({
        subscriptionStatusSelected: null
      });
    }
  };

  render() {
    const { translationsStore, status } = this.props;
    const { subscriptionStatusSelected } = this.state;

    return (
      <div className="SubscriptionStatusFilter" id="SubscriptionStatusFilter">
        <div className="filterTitle">
          {translationsStore.translate('subscriptionManager.filter.subscriptionStatus')}

          <span>
            {!isEmpty(subscriptionStatusSelected) && status !== false && (
              <span>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div className="selected">{translationsStore.translate(`subscriptionManager.statuses.${subscriptionStatusSelected}`)}</div>
                  <Icon style={{ marginLeft: '5px' }} type="close-circle" onClick={this.reset} />
                </div>
              </span>
            )}
          </span>
        </div>
        <Select value={subscriptionStatusSelected} onChange={this.selectSubscriptionStatus}>
          {this.props.subscriptionsStore.subscriptionStatuses.map(subscription => (
            <Select.Option value={subscription} key={subscription}>
              {translationsStore.translate(`subscriptionManager.statuses.${subscription}`)}
            </Select.Option>
          ))}
        </Select>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/SubscriptionManagerDashboard/SubscriptionAdvancedFilter/filters/SubscriptionStatusFilter/SubscriptionStatusFilter.js